export type ICheckpoint = {
  x: number;
  y: number;
  active: boolean;
  spriteKey?: string;
  activate(): void;
  isActive(): boolean;
  getPosition(): { x: number; y: number };
};

export type CheckpointData = { x: number; y: number; spriteKey?: string };

export class Checkpoint implements ICheckpoint {
  public x: number;
  public y: number;
  public active: boolean;
  public spriteKey?: string;
  constructor(x: number, y: number, spriteKey?: string) {
    this.x = x; this.y = y; this.spriteKey = spriteKey; this.active = false;
  }
  activate(): void { this.active = true; }
  isActive(): boolean { return this.active; }
  getPosition(): { x: number; y: number } { return { x: this.x, y: this.y }; }
}
